<!-- calendar source: https://codesandbox.io/s/monthly-calendar-vue-wdv9y -->

<template>
  <div>
    <vs-row>
      <vs-col vs-lg="6" vs-sm="12">
        <payments/>
      </vs-col>
      <vs-col vs-lg="6" vs-sm="12">
        <shippings/>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-lg="6" vs-sm="12">
        <locations />
      </vs-col>
      <vs-col vs-lg="6" vs-sm="12">
        <vs-row>
          <settings />
        </vs-row>
        <vs-row>
          <dailyAlert/>
        </vs-row>
        <vs-row>
          <information/>
        </vs-row>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import payments from "@/views/admin/payments";
import shippings from "@/views/admin/shippings";
import locations from "@/views/admin/locations";
import information from '@/views/admin/information';
import settings from "@/views/admin/settings";
import dailyAlert from "@/views/admin/dailyAlert";

export default {
  name: "order_options",
  data() {
    return {}
  },
  components: {payments, shippings, locations, information, settings, dailyAlert},
  methods: {}
}
</script>